import { useTranslation } from "react-i18next";

import { GqlProjectStatus } from "~/__generated__";
import GaiaDataList from "~/modules/app/components/GaiaDataList";
import GaiaPageGridComponent from "~/modules/app/components/GaiaPageGridComponent";
import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";
import useQueryStringGridModels from "~/modules/app/hooks/useQueryStringGridModels";
import ErrorScreen from "~/modules/app/screens/ErrorScreen";
import { convertParamsToQueryOptionsArray } from "~/modules/app/util/filterAndPaginationUtils";
import { useSessionStorageSearchParams } from "~/shared/hooks/useSessionStorageSearchParams";

import { useVisitListScreen_GetAll } from "./api/usePlannerVisitListScreen_GetAll";
import { useAdministratorColumns } from "./useAdministratorColumns";

const DEFAULT_PARAMS = {
    page: 0,
    pageSize: 50,
    projectStatus: [GqlProjectStatus.Confirmed],
    sortBy: "startTime",
    sortOrder: "desc",
};

export function PlannerVisitListScreen() {
    const { t } = useTranslation("planner");

    const { filterModel, onFilterModelChange, gridModels, gqlVariables } = useQueryStringGridModels(
        convertParamsToQueryOptionsArray,
        DEFAULT_PARAMS,
        useSessionStorageSearchParams,
    );

    const { data, loading, error, filterOptions, total } = useVisitListScreen_GetAll(gqlVariables.params);
    const columns = useAdministratorColumns();

    if (!data && !loading && error) {
        return <ErrorScreen error={error} />;
    }

    return (
        <GaiaPageLayoutColumn maxWidth="xl">
            <GaiaPageGridComponent title={t("visitListScreen.title")}>
                <GaiaDataList
                    data={data || []}
                    loading={loading}
                    error={error}
                    filterOptions={filterOptions}
                    totalRows={total || 0}
                    columns={columns}
                    filterModel={filterModel}
                    onFilterModelChange={onFilterModelChange}
                    gridModels={gridModels}
                />
            </GaiaPageGridComponent>
        </GaiaPageLayoutColumn>
    );
}
